// TODO: autocomplete
// TODO: test autcomplete-async without key
// TODO: noForm -> onChange((value)=>{}) not e.target.value
// import { memo } from "react";
// import { useEffect, useState } from "react";
import { useContext } from "react";
// eslint-disable-next-line import/no-cycle
import InputSwitch from "./InputSwitch";
import InputSwitchForm from "./InputSwitchForm";
import DisableContext from "../../Context/disableContext";
// import PTMSkeletableContent from "../PTMSkeletableContent";
// import InputLoadingContext from "../Context/InputLoadingContext";
// import useStore from "../../store";

function PTMInput(props) {
    const formDisabled = useContext(DisableContext);
    // const inputIsLoading = useContext(InputLoadingContext);

    const {
        type,
        noForm, // uses outer FormProvider
        disabled,
        required,
        fullWidth,
        fullHeight,
        neededWidth, // only select, for TextField + Select inside flex line
        options, // only select, autocomplete
        optionsFilter, // autocomplete-async
        getOptions, // autocomplete-async
        getSelectedOption, // autocomplete-async
        optionsKey, // only select, autocomplete(-async)
        optionsName, // only select, autocomplete(-async)
        optionsFormat, // only select, autocomplete(-async)
        labelFormat, // only select, autocomplete(-async)
        optionsValueType = "object", // only select, autocomplete(-async): "object" or "key"
        falseLabel, // only switch
        trueLabel, // only switch
        falseValueColor, // only switch
        trueValueColor, // only switch
        checked, // only switch
        align = "left", // only switch
        label,
        labelPlacement,
        name, // required unless noForm, as form field name
        placeholder,
        defaultValue = false,
        value,
        onChange,
        onBlur,
        onClick,
        onKeyDown,
        onInputChange, // autocomplete
        blurOnSelect, // autocomplete
        startAdornment,
        endAdornment,
        sx,
        className,
        children,
        multiline,
        rows,
        inputProps,
        pattern,
        filterDisabled,
        filterData,
        filterOptions,
        addOption,
        disableClearable,
        validate,
        allowShowPassword,
        allowGeneratePassword,
        customGeneratePasswordFunction,
        isLoading,
        maxHeight,
        autoFocus,
        allowCopy,
        clearField,
        menuItemStyle,
        icon,
        checkedIcon,
        color,
        freeSolo,
        allowEmpty,
        dateParseTemplate,
        allowNegative, // decimal
        thousandSeparator, // decimal
        decimalSeparator, // decimal
        decimalScale, // decimal
        fixedDecimalScale, // decimal
        inputLink,
        onClear,
        maxValue, // slider,
        minValue, // slider,
        marks, // slider,
        valueLabelDisplay, // slider
        valueLabelFormat, // slider
        step, // slider and text
        maxDateTime, // customdatepicker
        minDateTime, // customdatepicker
        onError,
        inputStyle,
        tabId, // for Boilerplates Dialog in CustomEditor
        disableEmptySelection,
        views,
        minTime,
        maxTime,
        minutesStep,
        disableFuture,
        disableIgnoringDatePartForTimeValidation,
        onContextMenu,
        forcedRootBlock,
    } = props;

    if (startAdornment?.type?.type?.name === "PTMInput" && !endAdornment?.props?.noForm) {
        throw new Error("startAdornment: PTMInput not supported for Formfields, because of current rerender bug with PTMInput in PTMInput");
    }

    if (endAdornment?.type?.type?.name === "PTMInput" && !endAdornment?.props?.noForm) {
        throw new Error("endAdornment: PTMInput not supported for Formfields, because of current rerender bug with PTMInput in PTMInput");
    }

    // FormControl
    // types: autocomplete, select, switch, default types
    // select: options: special props, current limitations: no start/endAdorment
    // switch: switch-true, switch-false: special props
    // label = undefined -> height: 28px including margin
    // label = !undefined -> height: 40px including margin
    return noForm || !name ? (
        // <PTMSkeletableContent condition={inputIsLoading}>
        <InputSwitch
            type={type}
            disabled={disabled}
            formDisabled={formDisabled}
            required={required}
            fullWidth={fullWidth}
            fullHeight={fullHeight}
            neededWidth={neededWidth}
            options={options}
            getOptions={getOptions}
            getSelectedOption={getSelectedOption}
            optionsKey={optionsKey}
            optionsName={optionsName}
            optionsFormat={optionsFormat}
            labelFormat={labelFormat}
            optionsValueType={optionsValueType}
            falseLabel={falseLabel}
            trueLabel={trueLabel}
            falseValueColor={falseValueColor}
            trueValueColor={trueValueColor}
            checked={checked}
            align={align}
            label={label}
            labelPlacement={labelPlacement}
            placeholder={placeholder}
            defaultValue={defaultValue}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            onClick={onClick}
            onKeyDown={onKeyDown}
            onInputChange={onInputChange}
            blurOnSelect={blurOnSelect}
            startAdornment={startAdornment}
            endAdornment={endAdornment}
            filterDisabled={filterDisabled}
            filterData={filterData}
            filterOptions={filterOptions}
            addOption={addOption}
            disableClearable={disableClearable}
            sx={sx}
            className={className}
            multiline={multiline}
            rows={rows}
            validate={validate}
            allowShowPassword={allowShowPassword}
            isLoading={isLoading}
            maxHeight={maxHeight}
            autoFocus={autoFocus}
            allowCopy={allowCopy}
            clearField={clearField}
            menuItemStyle={menuItemStyle}
            icon={icon}
            checkedIcon={checkedIcon}
            color={color}
            freeSolo={freeSolo}
            allowEmpty={allowEmpty}
            allowNegative={allowNegative}
            thousandSeparator={thousandSeparator}
            decimalSeparator={decimalSeparator}
            decimalScale={decimalSeparator}
            fixedDecimalScale={decimalSeparator}
            inputLink={inputLink}
            onClear={onClear}
            maxValue={maxValue}
            minValue={minValue}
            marks={marks}
            valueLabelDisplay={valueLabelDisplay}
            valueLabelFormat={valueLabelFormat}
            step={step}
            inputProps={inputProps}
            dateParseTemplate={dateParseTemplate}
            maxDateTime={maxDateTime}
            minDateTime={minDateTime}
            inputStyle={inputStyle}
            tabId={tabId}
            disableEmptySelection={disableEmptySelection}
            views={views}
            minTime={minTime}
            maxTime={maxTime}
            minutesStep={minutesStep}
            disableFuture={disableFuture}
            disableIgnoringDatePartForTimeValidation={disableIgnoringDatePartForTimeValidation}
            onContextMenu={onContextMenu}
            forcedRootBlock={forcedRootBlock}
        >
            {children}
        </InputSwitch>
        // </PTMSkeletableContent>
    ) : (
        // <PTMSkeletableContent condition={inputIsLoading}>
        <InputSwitchForm
            type={type}
            disabled={disabled}
            formDisabled={formDisabled}
            required={required}
            fullWidth={fullWidth}
            fullHeight={fullHeight}
            neededWidth={neededWidth}
            options={options}
            optionsFilter={optionsFilter}
            getOptions={getOptions}
            getSelectedOption={getSelectedOption}
            optionsKey={optionsKey}
            optionsName={optionsName}
            optionsFormat={optionsFormat}
            labelFormat={labelFormat}
            optionsValueType={optionsValueType}
            falseLabel={falseLabel}
            trueLabel={trueLabel}
            falseValueColor={falseValueColor}
            trueValueColor={trueValueColor}
            checked={checked}
            align={align}
            label={label}
            labelPlacement={labelPlacement}
            name={name}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onBlurForm={onBlur}
            onClick={onClick}
            onKeyDown={onKeyDown}
            onInputChange={onInputChange}
            blurOnSelect={blurOnSelect}
            startAdornment={startAdornment}
            endAdornment={endAdornment}
            sx={sx}
            className={className}
            multiline={multiline}
            rows={rows}
            inputProps={inputProps}
            pattern={pattern}
            filterDisabled={filterDisabled}
            filterData={filterData}
            filterOptions={filterOptions}
            addOption={addOption}
            disableClearable={disableClearable}
            validate={validate}
            allowShowPassword={allowShowPassword}
            allowGeneratePassword={allowGeneratePassword}
            customGeneratePasswordFunction={customGeneratePasswordFunction}
            isLoading={isLoading}
            maxHeight={maxHeight}
            autoFocus={autoFocus}
            allowCopy={allowCopy}
            clearField={clearField}
            menuItemStyle={menuItemStyle}
            icon={icon}
            checkedIcon={checkedIcon}
            color={color}
            freeSolo={freeSolo}
            allowEmpty={allowEmpty}
            allowNegative={allowNegative}
            thousandSeparator={thousandSeparator}
            decimalSeparator={decimalSeparator}
            decimalScale={decimalScale}
            fixedDecimalScale={fixedDecimalScale}
            inputLink={inputLink}
            onClear={onClear}
            maxValue={maxValue}
            minValue={minValue}
            marks={marks}
            valueLabelDisplay={valueLabelDisplay}
            valueLabelFormat={valueLabelFormat}
            step={step}
            dateParseTemplate={dateParseTemplate}
            maxDateTime={maxDateTime}
            minDateTime={minDateTime}
            onError={onError}
            inputStyle={inputStyle}
            tabId={tabId}
            disableEmptySelection={disableEmptySelection}
            views={views}
            minTime={minTime}
            maxTime={maxTime}
            minutesStep={minutesStep}
            disableFuture={disableFuture}
            disableIgnoringDatePartForTimeValidation={disableIgnoringDatePartForTimeValidation}
            onContextMenu={onContextMenu}
            forcedRootBlock={forcedRootBlock}
        >
            {children}
        </InputSwitchForm>
        /* </PTMSkeletableContent> */
    );
}

export default PTMInput;
